import { h, Fragment } from "preact";
import { useContext, useEffect, useState } from "preact/hooks";

import Popup from "./Popup";

import { Context, setLoginModalVisible } from "../lib/globalState";
import { useFirestore, useUser } from "../lib/preactfire";
import { addOverlay, removeContextMenu, removeOverlay } from "../lib/helper";

const ContextMenu = ({ obj }) => {
  const {
    state: { commentShare },
    dispatch,
  } = useContext(Context);

  const [alertVisible, setAlertVisible] = useState(false);

  const user = useUser();
  const db = useFirestore();

  useEffect(() => {
    removeOverlay();
    removeContextMenu();
    return () => {
      removeOverlay();
      removeContextMenu();
    };
  }, [alertVisible]);

  const onClickReport = (el) => {
    document.body.classList.add("report-active");
    el.currentTarget.parentNode.parentNode.parentNode.classList.add(
      "show-modal-now"
    );
    if (user) {
      setAlertVisible(true);
    } else {
      dispatch(setLoginModalVisible(true));
    }
  };

  const onClickShare = () => {
    const el = document.querySelector(`#share-icons-${obj?.id}`);
    setTimeout(() => {
      addOverlay();
      el.classList.add("show-action");
    }, 10);
  };

  const onReponseYes = () => {
    removeContextMenu();
    const commentRef = db.collection("comment").doc(`${obj.id}`);
    if (obj?.flags) {
      commentRef.update({
        flags: [
          ...obj?.flags,
          {
            user_id: user.uid,
            date: new Date(),
          },
        ],
      });
    } else {
      commentRef.update({
        flags: [
          {
            user_id: user.uid,
            date: new Date(),
          },
        ],
      });
    }
    setAlertVisible(false);
  };

  const onResponseNo = () => {
    removeContextMenu();
    setAlertVisible(false);
  };

  return (
    <Fragment>
      <div className="comment-right-menu">
        <ul>
          <li id="report-list-item" onClick={(e) => onClickReport(e)}>
            Report
          </li>
          {/* Show Share action only when enable in widget settings */}
          {commentShare && (
            <li id="share-list-item" onClick={onClickShare}>
              Share
            </li>
          )}
        </ul>
      </div>

      {alertVisible && (
        <Popup setVisible={setAlertVisible}>
          <div>Report Message</div>
          <p>
            Would you like to report this message as inappropriate? The reported
            content will not be displayed to you.{" "}
          </p>
          <div className="popup-button-wrapper">
            <button onClick={onResponseNo}>No</button>
            <button className="button-info" onClick={onReponseYes}>
              Yes
            </button>
          </div>
        </Popup>
      )}
    </Fragment>
  );
};

export default ContextMenu;
